import { CandidateProfileDto, CandidateStatusCountsDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useQuery } from '@tanstack/react-query';

export const CANDIDATE_STATUS_COUNTS_KEY = 'candidate-status-counts';

export const useGetCandidateStatusCounts = (adminUserId: string) => {
  const { adminCandidatesApi } = useApiClient();

  const query = useQuery<CandidateStatusCountsDto>({
    enabled: !!adminUserId,
    queryFn: async () => (await adminCandidatesApi.getCandidateStatusCounts(adminUserId)).data,
    queryKey: [CANDIDATE_STATUS_COUNTS_KEY, adminUserId],
  });

  return { counts: query.data, refetchCounts: query.refetch };
};

export const useGetCandidateProfile = (adminUserId: string, candidateId: string | undefined) => {
  const { adminCandidatesApi } = useApiClient();

  const query = useQuery<CandidateProfileDto>({
    enabled: !!adminUserId && !!candidateId,
    queryFn: async () =>
      (await adminCandidatesApi.getCandidateProfile(adminUserId, candidateId ?? '')).data,
    queryKey: [QueryKeyEnum.ADMIN_CANDIDATE_PROFILE, adminUserId, candidateId],
  });

  return { error: query.error, isLoading: query.isLoading, profile: query.data };
};
